import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledFooter = styled.div`
  font-family: ${(props) => props.theme.fontText};
  min-height: 235px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-top: 23px;
  background-color: ${(props) => props.theme.white};
  border-top: 1px solid ${(props) => props.theme.borderBottom};

  .footer-contacts {
    .footer-title {
      display: flex;
      justify-content: space-between;

      p {
        margin: 0;
        font-family: ${(props) => props.theme.fontText};
        font-size: 24px;
        font-weight: 500;
        line-height: 38px;
      }

      .footer-icon-wrapper {
        display: flex;
        flex-direction: row;
        gap: 8px;
      }
    }

    .footer-content-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      margin: 53px 0 27px 0;

      p {
        margin: 0;
        line-height: 28px;
      }

      .footer-content-container {
        display: flex;
        align-items: flex-start;
        font-size: 16px;
        gap: 10px;

        a {
          text-decoration: none;
          color: inherit;
        }

        img {
          padding: 0 5px 0 0;
        }
      }

      .footer-content-container-right {
        display: flex;
        flex-direction: column;
        gap: 13px;
      }

      .footer-content-container-end {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 13px;
      }

      .footer-content-container:first-child {
        width: 100%;
        max-width: 346px;
      }
    }

    .contact-icon img {
      width: 24px;
      height: 24px;
    }
  }

  .footer-desktop-print {
    display: flex;
    height: 85px;
    width: 100%;
    overflow: hidden;
    background-image: url('/svgs/landing-page-watermark.svg');
    background-size: auto;
    background-repeat: repeat-x;
  }

  .mobile-footer-image-wrapper {
    display: none;
    overflow: hidden;
  }

  .footer-copyright {
    padding: 54px 0;
    color: ${(props) => props.theme.white};
    background-color: ${(props) => props.theme.brand01};
    font-size: 14px;
    font-weight: 400;

    .container {
      display: flex;
      flex-wrap: wrap;
      gap: 32px;
      align-items: center;
      justify-content: space-between;
      
      .policies {
        display: flex;
        gap: 16px;

        a {
          color: ${(props) => props.theme.white};

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .footer-content-container-end {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 13px;
    .footer-content {
      p {
        font-size: 16px;
      }
    }

    p {
      margin: 0;
      font-family: ${(props) => props.theme.fontText};
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
    }
  }

  @media only screen and (max-width: 1600px) {
    .footer-contacts {
      .footer-content-wrapper {
        flex-wrap: wrap;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    padding-bottom: 100px;

    .footer-title {
      p {
        font-size: 1.125rem !important;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    background-color: transparent;
    border-top: none;
    margin-top: 30px;

    .footer-contacts {
      padding: 0;

      .footer-content-wrapper {
        flex-direction: column;
        gap: 22px;
        margin: 30px 0 56px 0;

        .footer-content-container-right,
        .footer-content-container-end {
          display: flex;
          flex-direction: column-reverse;
          align-items: flex-start;
          gap: 22px;
        }

        .footer-content-container {
          display: flex;
          align-items: flex-start;
          gap: 10px;

          .footer-content {
            p {
              margin-bottom: 0;
              line-height: 28px;
            }
          }
        }
      }
    }

    .mobile-footer-image-wrapper {
      display: flex;
      height: 41px;
      width: 100%;
    }

    .footer-copyright {
      padding: 0;
      color: ${(props) => props.theme.black};
      background-color: transparent;

      .container {
        flex-direction: column-reverse;
        align-items: flex-start;

        &>div {
          width: 100%;

          &.copyright-text {
            text-align: center;
          }

          &.policies {
            flex-direction: column;

            a {
              color: ${(props) => props.theme.black};
            }
          }
        }
      }
    }

    .desktop-footer-image-wrapper {
      display: none;
    }

    .footer-image-wrapper {
      display: none;
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    margin-top: 0px;
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .footer-contacts {
      .footer-title {
        p {
          margin: 0;
          padding: 0;
          font-size: 18px;
          font-weight: 500;
        }

        .footer-icon-wrapper {
          display: none;
        }
      }

      .footer-content-wrapper {
        margin: 24px 0 51px 0;
      }

      .footer-content p {
        color: ${(props) => props.theme.colorText};
      }
    }

    .footer-content-container-end {
      display: none !important;
    }
  }
`;
